/* eslint-disable react/jsx-props-no-spreading */
import { useState, useEffect, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route, useNavigate,
} from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import Confirmation from 'views/Confirmation';
import Payements from 'views/Payements';
import Investments from 'views/Investments';
import verifyToken from 'store/features/roles/actions';
import Loading from 'components/library/Loading';
import Error from 'views/Error/Error';
import Navigation from 'components/Navigation';
import * as statuses from 'store/states';
import ConfirmationSuccess from 'views/ConfirmationSuccess';
import ConfirmationError from 'views/ConfirmationError';
import { AppDispatch, RootState } from 'store/types';

type RouteProps = {
  path: string,
  auth: boolean,
  component: React.ComponentType;
  roles: string[],
};

const ROUTES: RouteProps[] = [
  {
    path: '/:id/confirmation/error',
    component: ConfirmationError,
    auth: true,
    roles: []
  },
  {
    path: '/:id/confirmation/success',
    component: ConfirmationSuccess,
    auth: true,
    roles: []
  },
  {
    path: '/:id/confirmation',
    component: Confirmation,
    auth: true,
    roles: []
  },
  {
    path: '/:id/paiement',
    component: Payements,
    auth: true,
    roles: []
  },
  {
    path: '/:id',
    component: Investments,
    auth: false,
    roles: []
  },
  {
    path: '/',
    component: Error,
    auth: false,
    roles: []
  }
];

interface Props {
  route: RouteProps;
  status: typeof statuses[keyof typeof statuses];
  authorizedRole: string[]
}

function RouteWithSubRoutes({
  route, status, authorizedRole,
}: Props) {
  const [showRoute, setShowRoute] = useState(false);
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    const debug = new URLSearchParams(window.location.search).get('debug');
    if (debug === 'true' || debug === 'false') window.sessionStorage.setItem('debug', debug);
    dispatch(verifyToken(route.auth));
  }, [route.auth, dispatch]);

  useEffect(() => {
    if (route.roles && route.roles.length > 0 && status === 'SUCCEEDED') {
      for (const role of route.roles) {
        if (!authorizedRole.includes(role)) {
          if (history.length === 1) {
            document.location.assign(`https://${process.env.REACT_APP_DEBUG ? 'dev-' : ''}auth.ayomi.fr`);
          } else {
            navigate(-1);
          }
        } else {
          setShowRoute(true);
        }
      }
    } else {
      setShowRoute(true);
    }
  }, [status]);

  if (route.auth && (status !== 'SUCCEEDED' || !showRoute)) {
    return <Loading />;
  }
  return (
    <route.component />
  );
}

const mapStateToProps = (state: RootState) => ({
  authorizedRole: state.roles?.roles,
  status: state.roles?.status,
});

const ConnectedRouteWithSubRoutes = connect(mapStateToProps)(RouteWithSubRoutes);

export default function RouteConfig() {
  return (
    <Router>
      <div className="main">
        <Suspense fallback={<Loading />}>
          <Navigation />
          <Routes>
            {ROUTES.map((route) => (
              <Route key={route.path} path={route.path} element={<ConnectedRouteWithSubRoutes route={route} />} />
            ))}
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}
